import React from "react";
import ReactDOM from "react-dom/client";
import { ErrorBoundary } from "shared/hoc";
import App from "./app/index";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <ErrorBoundary type="app">
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
